'use client';

import { Media } from '@/payload-types';
import Image from 'next/image';

type ImageGridProps = {
    images: {
        afbeelding: string | Media;
    }[];
};

export default function ImageGrid({ images }: ImageGridProps) {
    return (
        <div className="">
            <div className="mx-2 grid grid-cols-1 gap-2 sm:grid-cols-2 lg:mx-5 lg:gap-5">
                {images.map((image, imgIndex) => {
                    const isVideo =
                        typeof image.afbeelding !== 'string' &&
                        image.afbeelding.mimeType?.startsWith('video/');
                    const src =
                        typeof image.afbeelding === 'string'
                            ? '/placeholder.svg'
                            : image.afbeelding.url || '/placeholder.svg';

                    return isVideo ? (
                        <video
                            key={imgIndex}
                            src={src}
                            className="aspect-square h-full w-full rounded-lg object-cover"
                            loop
                            muted
                            autoPlay
                            playsInline
                        />
                    ) : (
                        <Image
                            key={imgIndex}
                            src={src}
                            alt={
                                typeof image.afbeelding === 'string'
                                    ? ''
                                    : image.afbeelding.alt
                            }
                            width={
                                typeof image.afbeelding === 'string'
                                    ? 745
                                    : image.afbeelding.width || 745
                            }
                            height={
                                typeof image.afbeelding === 'string'
                                    ? 281.2
                                    : image.afbeelding.height || 281.2
                            }
                            quality={100}
                            className="bg-accent aspect-square h-full w-full rounded-lg object-cover"
                        />
                    );
                })}
            </div>
        </div>
    );
}
